import { Binder, BinderPropertyDescriptor, IBinding } from "../../binding/binding";
import { View } from "../../uiPatterns/mvvm/view";
import { ViewModel } from "../../uiPatterns/mvvm/viewmodel";
import { ViewGenerator } from "../viewGenerator";

export class SamePropertyNamesBinder{
    ///todo
    private static objectPrototype = Object.getPrototypeOf(new Object());
    ///todo
    private static getAllEntries(obj:any):Set<string>{
        let result : any[] = [];
        let o = obj;
        do{
            let names = Object.getOwnPropertyNames(o);
            let desc = Object.getOwnPropertyDescriptors(o);
            let map = names.map(x=>[x,desc[x]]);
            result.push(...map.filter(x=>x[1]['value']===undefined && (<any>x[0]).startsWith('__')==false))
            o=Object.getPrototypeOf(o);
        }while(o!=null && o!=this.objectPrototype);
        return new Set(result.map(x=>x[0]));
    }
    public static bindSourceAndDestination(source,destination):IBinding[]{
        
        let sourceProperties =this.getAllEntries(source);
        let destinationProperties = this.getAllEntries(destination);
        let intersect = [...sourceProperties].filter(i => destinationProperties.has(i));
        let result = intersect.map(x=>Binder.createBinding(new BinderPropertyDescriptor(destination,x),null,new BinderPropertyDescriptor(source,x)));
        return result;
    }
}

export class BindedView{
    public view:View<ViewModel>;
    public element:Element;
    private bindings : IBinding[];
    private viewModel:ViewModel;
    private viewSelector: (viewmodel: ViewModel) => View<ViewModel>;

    constructor(viewSelector?:(viewmodel: ViewModel) => View<ViewModel>) {
        this.bindings = [];
        this.viewSelector = viewSelector!=null ? viewSelector : x=>x.GetDefaultView();
    }
    private create():Element{
        this.view = this.viewSelector(this.viewModel);
        if(this.view==null) this.view = this.viewModel.GetDefaultView();
        if(this.view==null) return null;
        if(this.view instanceof HTMLElement){
            let view = (<any>this.view).binderRelatedView;
            this.bindings =  SamePropertyNamesBinder.bindSourceAndDestination(this.viewModel,view);
        } else{
            this.view.dataContext = this.viewModel;
            this.bindings =  SamePropertyNamesBinder.bindSourceAndDestination(this.viewModel,this.view);
        }
        this.element = ViewGenerator.GetHtml(this.view);
        return this.element;
    }


    update(viewModel:ViewModel):Element{
        this.release();
        this.viewModel = viewModel;
        if(this.viewModel){
            return this.create();
        }else{
            return null;
        }
    }
    
    release(){
        this.releaseCurrentBindings();
        this.bindings.forEach(x=>x.release());
        this.view = null;
        this.element = null;
    }

    private releaseCurrentBindings(){
        if(this.view && this.view.htmlBridges) 
            this.view.htmlBridges.forEach(x=>x.release());
    }
}